import { graphql } from "./generated/gql";

export const AvailableScheduleQuery = graphql(`
  query AvailableSchedule {
    availableSchedule {
      candidate {
        name
        email
        status
      }
      scheduleConfig {
        durationMinutes
        scheduleTitle
        scheduleDescription
      }
      currentBooking {
        interviewId
        startTime
        endTime
        zoomMeetingUrl
      }
      availableSlots {
        startTime
        endTime
      }
      stakeholderContext {
        recipientNames
      }
    }
  }
`);

export const BookInterviewMutation = graphql(`
  mutation BookInterview($input: BookInterviewInput!) {
    bookInterview(input: $input) {
      success
      errorMessage
      interview {
        interviewId
        startTime
        endTime
        zoomMeetingUrl
        status
      }
    }
  }
`);

export const CancelBookedInterviewMutation = graphql(`
  mutation CancelBookedInterview {
    cancelBookedInterview {
      success
      errorMessage
    }
  }
`);
